import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import config from 'SRC/config/config.json'

import { formatPriceEnding } from '../../../../../../functions'

export const Price = ({packages}) => {
  const { t } = useTranslation('common')
  const text = config.registrationForm.package.price

  return <tr>
    <td><strong>{t(text)}</strong></td>
    {
      packages.map(item => <td key={item.id}>{formatPriceEnding(item.price)}</td>)
    }
  </tr>
}
Price.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    price: PropTypes.number
  })).isRequired
}

Price.defaultProps = {
  packages: []
}
